<template>
    <!-- MODAL GENERIC -->
    <b-modal ref="free-modal" id="free-modal" size="xl" :hide-header="screenSize > 575" hide-footer class="modal-box" body-class="p-0" @hide="cleanRoute">

    <b-container fluid>
        <b-row :class="screenSize > 992 ? 'mx-5 my-5 text-center' : 'mx-1 my-1 text-center' " v-if="true">
          <!-- VIDEO CONTENT -->
          <DefaultVideoComponent :videoUrl="videoUrl" v-if="videoUrl !== '' "/>
          <!-- IMAGE CONTENT -->
          <div> 
            <b-img :src="image" v-if="image !== '' " fluid-grow alt="Responsive image" style="border-radius: 2rem;"></b-img>
          </div>
        </b-row>
        <!-- TITLE -->
        <b-row class="mx-5 my-5">
          <h2 class="font-weight-bold mb-0">{{ title }}</h2>
        </b-row>

        <b-row class="mx-5 mt-0 mb-5">
          <!-- LEFT COLUMN -->
          <b-col :cols="screenSize > 992 ? 6 : 12" style="padding-left: 0px;">
            <div>
              <!-- SUBTITLE -->
              <p v-if="subtitle !== '' " class="font-weight-bold">{{ subtitle }}</p>
              
              <!-- TEXT -->
              <FreeTextLeftModal />
              
              <!-- COUPOM CODE -->
              <!-- <p>This is your gift code: <span class="font-weight-bold">{{ coupom }}</span></p> -->
            </div>
            <!-- BUTTON -->
            <div class="button-purchase-perk" v-if="leftButton !== '' ">
              <b-link :href="ontraportUrl" target="_blank">
                <b-button
                  variant="light"
                  >
                  {{ leftButton }}
                  </b-button>
                </b-link>
            </div>
          </b-col>

          <!-- RIGHT COLUMN -->
          <b-col :style="screenSize > 992 ? 'padding-right: 0px; padding-left: 50px;' : '' ">
            <div :class="screenSize < 992 ? 'divider' : '' "></div>

            <div v-if="hasReview">
              <p class="font-weight-bold">Reviews</p>
              <div class="mt-3 mb-4" v-for="(review) in reviews" :key="review.reviewId" >
               <p class="font-italic" v-for="(paragraph) in review.reviewText" :key="paragraph.paragraphId">
               {{paragraph.paragraphText}}
               </p>
               <div>
                <b-avatar variant="light" :src="review.reviewImg" style="margin-right: 1rem;"></b-avatar>
                <span class="mr-auto font-weight-bold">{{review.reviewName}}</span>
                | {{review.reviewDescription}}
               </div>
              </div>
            </div>

            <div v-if="false">
              <p class="font-weight-bold">Leave a Review</p>
              <div class="mb-4">
               <p>I'm a text I'm a text I'm a text I'm a text I'm a text I'm a text I'm a text I'm a text I'm a text I'm a text I'm a text I'm a text I'm a text I'm a text</p>

               <p>I'm a text I'm a text I'm a text I'm a text I'm a text I'm a text I'm a text I'm a text I'm a text I'm a text I'm a text I'm a text I'm a text I'm a text</p>
              </div>

              <ReviewForm />
            </div>

            <div v-if="rightButton !== '' ">
              <p class="font-weight-bold">Share a review</p>
              <div class="mb-4">
              <FreeTextRightModal />
              </div>

              <ReviewForm :rightButton="rightButton" :messageTitle="title"/>
            </div>

          </b-col>
        </b-row>        
      </b-container>
    
    </b-modal>
</template>

<script>
import DefaultVideoComponent from '@/components/centre/DefaultVideoComponent.vue';
import FreeTextLeftModal from '@/components/centre/perks/free/FreeTextLeftModal.vue';
import FreeTextRightModal from '@/components/centre/perks/free/FreeTextRightModal.vue';
import ReviewForm from '@/components/centre/ReviewForm.vue';
import ModernCosmetics from "@/assets/images/centre/perks/perks-modal/ModernCosmetics.jpg";

export default {
  name: "FreeModalComponent",
  components: {
    DefaultVideoComponent,
    FreeTextLeftModal,
    FreeTextRightModal,
    ReviewForm,
  },
  props: ["id", "customerInfo", "freeCardsData"],
  mounted() {
    // if (this.$route.query.id) {
    //   this.$refs['free-modal'].show();
    // }

    if (this.$route.name === 'Perks' && this.$route.query.id) {
      let index = parseInt(this.$route.query.id) - 1;
      if(this.freeCardsData[index].hasModal) {
        this.$refs['free-modal'].show();
        this.title = this.freeCardsData[index].modalTitle;
        this.subtitle = this.freeCardsData[index].modalSubtitle;
        this.leftButton = this.freeCardsData[index].leftButton;
        this.rightButton = this.freeCardsData[index].rightButton;
        this.image = this.freeCardsData[index].modalImage;
        this.videoUrl = this.freeCardsData[index].modalVideo;
        this.ontraportUrl = this.freeCardsData[index].modalUrl;
        this.reviews = this.freeCardsData[index].reviews;
        this.hasReview = this.freeCardsData[index].hasReview;
      }
    }

    this.$root.$on("free-content", (content) => {
      this.title = content.modalTitle;
      this.subtitle = content.modalSubtitle;
      this.leftButton = content.leftButton;
      this.rightButton = content.rightButton;
      this.image = content.modalImage;
      this.videoUrl = content.modalVideo;
      this.ontraportUrl = content.modalUrl;
      this.reviews = content.reviews;
      this.hasReview = content.hasReview;

    });
    this.screenSize = window.innerWidth;
  },
  data() {
    return {
      modernCosmeticsImg: ModernCosmetics,
      videoUrl: "",
      image: "",
      title: "",
      subtitle: "",
      leftButton: "",
      rightButton: "",
      ontraportUrl: "",
      reviews: [],
      hasReview: true,
      screenSize: 1024,
    };
  },
  methods: {
    cleanRoute() {
      this.$router.push({
        name: "Perks",
        query: { category: this.$route.query.category },
      }).catch(()=>{});
    },
  },
};
</script>

<style scoped lang="scss">
div.container-fluid {
  padding: 31px;
}

.button-purchase-perk {
  display: flex;
  justify-content: center;
  button {
    font-weight: 700;
    background-color: black; 
    color: #E7E7E7; 
    border: none;
    border-radius: 0.4rem;
    padding: 0.5rem 4rem 0.5rem 4rem;
    margin-top: 1rem;
    &:hover {
      background-color: #E7E7E7;
      color: black; 
    }
  }
}

.divider {
  border: 1px solid #838383;
  margin: 1.4rem 1rem;
}
</style>
